export default {"src":"/_next/static/media/GoNoodleLogo_Registered_Reverse.b8bc0589.svg","height":181,"width":1056,"blurWidth":0,"blurHeight":0};